import React from 'react';
import { connect } from 'react-redux';

import { getGrowls } from 'store/ducks/ui';

import { Ul, Li } from './styles';

const GrowlMessage = ({ message, ...props }) => <Li {...props}>{message}</Li>;

const Growl = ({ messages }) => (
  <Ul>
    {messages.map(msg => (
      <GrowlMessage key={msg.id} {...msg} />
    ))}
  </Ul>
);

export default connect(state => ({ messages: getGrowls(state) }))(Growl);
